import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import MessageViewer from './components/MessageViewer';
import RecipientEventView from './components/RecipientEventView';

function AppContent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Check if user is logged in (token in localStorage)
    const token = localStorage.getItem('timeLockToken');
    const userData = localStorage.getItem('timeLockUser');
    if (token && userData) {
      setIsLoggedIn(true);
      setUser(JSON.parse(userData));
    }
  }, []);

  const handleLogin = (loginUser) => {
    setUser(loginUser);
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('timeLockToken');
    localStorage.removeItem('timeLockUser');
    setIsLoggedIn(false);
    setUser(null);
  };

  // Public message viewer - no login required
  const isViewingMessage = location.pathname.startsWith('/view/');
  const isViewingEvent = location.pathname.startsWith('/event/');

  if (isViewingMessage) {
    const token = location.pathname.split('/view/')[1];
    return <MessageViewer token={token} />;
  }

  if (isViewingEvent) {
    const token = location.pathname.split('/event/')[1];
    return <RecipientEventView token={token} />;
  }

  return (
    <div className="app">
      {isLoggedIn ? (
        <Dashboard user={user} onLogout={handleLogout} />
      ) : (
        <Login onLogin={handleLogin} />
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </Router>
  );
}

export default App;
